// modules
import { createSelector } from 'reselect'
import { get } from 'lodash'

import { addAllValue } from 'src/utils/v5/DataTrees'

const ribbonManagement = (state) => state.admin.ribbonManagement

export const companiesFullList$ = createSelector(
  ribbonManagement,
  ({ companiesFullList = [] }) =>
    companiesFullList.map((company) => ({
      ...company,
      title: get(company, 'name', ''),
      value: get(company, 'uuid')
    }))
)

// TODO allItem refactor or maybe all of this
export const companiesFullListWithAllAnt5$ = createSelector(
  companiesFullList$,
  (companiesFullList = []) =>
    addAllValue({
      list: companiesFullList,
      convertList: false,
      allItem: {
        key: 'all',
        title: 'All Companies',
        label: 'All Companies',
        value: ''
      }
    })
)
